export const ru = {
    dashboard: 'Дэшборд',
    liveStats: 'Статистика за сегодня',
    viewsToday: 'Просмотры сегодня',
    subscription: 'Подписка',
    activity: 'Активность',
    views_count: 'просмотров',
    until: 'до',
    hoursShort: 'ч',
    unknownDish: 'Неизвестное блюдо',
    unlimited: 'Бессрочно',
    expired: 'истекла',
    expiringSoon: 'подходит к концу',
    extend: 'Продлить',
    daysShort: 'дн.',
    gracePeriodActive: 'Действует льготный период',
    remaining: 'осталось',
    renewToKeepAccess: 'Продлите подписку, чтобы не потерять доступ',
    analyticsLocked: 'Аналитика заблокирована',
    availableInPlans: 'Доступно в тарифах',
    viewTariffs: 'Посмотреть тарифы',
    and: 'и',
    marketingToolsDesc: 'Продвинутые инструменты маркетинга для вашего заведения.',
    activeBanners: 'Активные Баннеры',
    availableInSmart: 'Доступно в тарифе Smart',
    addVariant: 'Добавить вариант',
    mapLink: 'Ссылка на 2ГИС',
    mapLinkPlaceholder: 'https://go.2gis.com/...',
    noBanners: 'Баннеров нет. Добавьте их в настройках.',
    tapToOpenMap: '*нажмите на эту кнопку чтобы посмотреть в 2гис',

    usersManagement: 'Управление пользователями',
    logs: 'Логи активности',
    createCafe: 'Создать кафе',
    logout: 'Выйти',
    allCafes: 'Всего заведений',
    users: 'Аккаунт',
    activeMenus: 'Активных меню',
    yourCafes: 'Ваши заведения',
    all: 'Основное меню',
    gridView: 'Сетка',
    listView: 'Список',
    manage: 'Управлять',
    analytics: 'Аналитика',
    openMenu: 'Открыть меню',
    viewMenu: 'Открыть меню',
    network: 'Сеть',
    password: 'Пароль',
    tariffs: 'Подписка',
    qrCodeMenu: 'QR-код',
    messages: 'Сообщения',
    support: 'Поддержка',
    account: 'Аккаунт',
    refresh: 'Обновить',
    downloadReport: 'Скачать отчет в PDF',
    outsidersDesc: 'Аутсайдеры с низким трафиком',
    guestsSearchingDesc: 'То, что ищут через поиск',
    noViewsDesc: 'Позиции без просмотров',
    searchDishes: 'Поиск блюд...',
    noDishes: 'Блюд не найдено.',
    availability: 'В наличии',
    stopList: 'Стоп-лист',
    available: 'Доступно',
    unavailable: 'Нет в наличии',
    addToCart: 'В корзину',
    price: 'Цена',
    description: 'Описание',
    nutrients: 'Пищевая ценность',
    stickers: 'Метки',
    weight: 'Граммовка',
    proteins: 'Белки',
    fats: 'Жиры',
    carbs: 'Углеводы',
    calories: 'Ккал',
    grams: 'г',
    ml: 'мл',
    save: 'Сохранить',
    cancel: 'Отмена',
    editDish: 'Редактировать блюдо',
    addDish: 'Добавить блюдо',
    category: 'Категория',
    name: 'Название',
    dishName: 'Название блюда',
    dishPrice: 'Цена',
    selectCategory: 'Выберите категорию',
    optionalInfo: 'Дополнительная информация (КБЖУ и метки)',
    uploadImage: 'Перетащите изображение сюда',
    uploadHint: 'или нажмите для выбора (PNG, JPG до 5MB)',
    activeIconTitle: 'Блюд в наличии',
    stopListIconTitle: 'Блюд в стоп-листе',
    globalStopList: 'Глобальный стоп-лист',
    returnToAvailability: 'Вернуть в наличие',
    stats24h: 'Просмотры за 24ч',
    topDish: 'Популярное блюдо',
    lastChanges: 'Последние изменения',
    topDishesWidget: 'Топ блюд',
    cafesLabel: 'Кафешки',
    nothingFoundHeader: 'Упс!',
    nothingFoundText: 'По вашему запросу ничего не найдено. Попробуйте поискать иначе.',
    clearSearch: 'Очистить поиск',
    // New ones
    energyValueLabel: 'Энерг. ценн.',
    noDescription: 'Нет описания',
    downloadApp: 'Скачать приложение',
    installSuccess: 'Приложение успешно установлено!',
    pwaFallbackTitle: 'Установка приложения',
    pwaFallbackMessage: 'Чтобы установить приложение, нажмите на меню браузера (три точки) и выберите "Добавить на гл. экран" или "Установить".',
    remove: 'Убрать',
    receiptTitle: 'ЧЕК',
    headerQty: 'Кол-во',
    subtotal: 'Сумма заказа:',
    serviceCharge: 'Обслуживание',
    totalAmount: 'ИТОГО:',
    clearCart: 'Очистить чек',
    close: 'Закрыть',
    nameHeader: 'Название',
    hidden: 'Скрыта',
    basicInfo: 'Основные данные',
    variants: 'Варианты',
    regularPrice: 'Обычная цена',
    addVariants: 'Добавить варианты',
    sizes: 'Размеры',
    typesWithPhoto: 'Виды (с фото)',
    optional: 'Дополнительно',
    bannerManagement: 'Управление баннерами',
    addNewBanner: 'Добавить новый баннер',
    titleOptional: 'Название (опционально)',
    bannerImage: 'Изображение баннера',
    recommendedSize: 'Рекомендуется 2:1',
    addBanner: 'Добавить баннер',
    editBanner: 'Редактировать баннер',
    saveChanges: 'Сохранить изменения',
    noTitle: 'Без названия',
    confirmation: 'Подтверждение',
    areYouSure: 'Вы уверены?',
    yesDelete: 'Да, удалить',
    loading: 'Загрузка...',
    processing: 'Обработка...',
    dbError: 'Ошибка БД',
    tryAgain: 'Попробовать снова',
    systemOnline: 'Система: Online',
    systemOffline: 'Система: Offline',
    database: 'База данных',
    storage: 'Файлы (Storage)',
    active: 'Активен',
    hiddenStatus: 'Скрыт',
    edit: 'Изменить',
    delete: 'Удалить',
    categoryManagement: 'Управление Категориями',
    categoryDescriptionPlaceholder: 'Описание категории (послание гостям)',
    sections: 'Разделы',
    newCategoryPlaceholder: 'Название новой категории (напр. Напитки)',
    add: 'Добавить',
    show: 'Показать',
    hide: 'Скрыть',
    categoriesEmpty: 'Список категорий пуст.',
    settings: 'Настройки',
    basicSettings: 'Основные настройки',
    cafeName: 'Название заведения',
    address: 'Адрес',
    servicePercent: 'Процент обслуживания (%)',
    maintenanceMode: 'Режим обслуживания',
    maintenanceDesc: 'Скрывает меню от гостей',
    saveSettings: 'Сохранить настройки',
    profileData: 'Данные профиля',
    firstName: 'Имя',
    lastName: 'Фамилия',
    emailCannotBeChanged: 'Email нельзя изменить',
    updateProfile: 'Обновить профиль',
    security: 'Безопасность',
    newPassword: 'Новый пароль',
    minChars: 'Минимум 6 символов',
    confirmPassword: 'Подтвердите пароль',
    changePassword: 'Сменить пароль',
    passwordsDoNotMatch: 'Пароли не совпадают',
    passwordTooShort: 'Пароль должен быть не менее 6 символов',
    passwordChangedSuccess: 'Пароль успешно изменен',
    profileUpdated: 'Профиль обновлен',
    menuByCategories: 'Меню по категориям',
    quickDishSearch: 'Быстрый поиск блюда...',
    clickToChange: 'Нажмите, чтобы изменить',
    editPhoto: 'Редактировать',
    changePhoto: 'Изменить',
    publishedDraft: 'ОПУБЛИКОВАНО (ЧЕРНОВИК)',
    saveDraft: 'В черновик',
    dishDeleted: 'Блюдо удалено',
    additional: 'Дополнительно',
    welcomeAdmin: 'Добро пожаловать в админ-панель!',
    noCafeMessage: 'Похоже, за вашей учетной записью еще не закреплено кафе. Пожалуйста, обратитесь к администратору платформы.',
    categoryDeleteWarning: 'В категории',
    dishes: 'блюд(а)',
    deleteCategoryWarning: 'Если вы удалите её, эти блюда останутся "без категории".',
    deleteCategoryConfirm: 'Вы точно хотите удалить категорию',
    categoryAdded: 'Категория добавлена!',
    dishAdded: 'Блюдо добавлено успешно!',
    dishDuplicated: 'Блюдо продублировано!',
    saved: 'Изменения сохранены',
    categoryDeleted: 'Категория удалена',
    lightTheme: 'Светлая тема',
    darkTheme: 'Темная тема',
    categoryExists: 'Такая категория уже существует!',
    categoryUpdated: 'Категория обновлена',
    manageSections: 'Управление разделами',
    sectionName: 'Название раздела',
    categoryName: 'Название категории',
    noSection: 'Без раздела',
    visible: 'Видима',
    hiddenMsg: 'Скрыта',
    uploadError: 'Ошибка при загрузке фото',
    saveError: 'Ошибка сохранения',
    updateError: 'Ошибка обновления',
    deleteError: 'Ошибка удаления',
    accessError: 'Ошибка доступа',
    syncError: 'Ошибка синхронизации',
    networkError: 'Сетевая ошибка',
    uncategorized: 'Без категории',
    cafeNotFound: 'Кафе не найдено или ссылка неверна.',
    backToHome: 'Вернуться на главную',
    loadingError: 'Произошла ошибка при загрузке меню.',
    maintenanceTitle: 'Технические работы',
    maintenanceText: 'Мы скоро вернемся!',
    temporarilyClosed: 'Скоро вернемся',
    menuSuspendedTitle: 'Меню временно недоступно',
    menuSuspendedText: 'Заведение приостановило работу онлайн-меню. Пожалуйста, обратитесь к персоналу.',
    error: 'Ошибка',
    attention: 'Внимание',
    thisCategory: 'эту категорию',
    owner: 'Владелец',
    notSpecified: 'Не указан',
    errorSendingRequest: 'Ошибка отправки запроса',
    dishLimitReached: 'Лимит блюд для тарифа %plan% исчерпан (%limit%). Перейдите на Smart для безлимита.',
    ageRestriction: 'Ограничение 21+',
    ageGateTitle: 'Алкогольные напитки 21+',
    ageGateMessage: 'Для просмотра этой категории подтвердите, что Вам есть 21 год',
    ageGateConfirm: 'Подтверждаю',
    passwordRuleLength: 'Используйте не менее 6 символов',
    passwordRuleUpper: 'Не забудьте про заглавную букву',
    passwordRuleNumber: 'Добавьте хотя бы одну цифру',
    passwordRuleLatin: 'Только латинские символы',
    passwordRuleMatch: 'Пароли совпадают',
    currentPassword: 'Текущий пароль',
    enterPassword: 'Введите пароль',
    enterNewPassword: 'Введите новый пароль',
    incorrectPassword: 'Неверный текущий пароль',
    modifiers: 'Модификаторы / Ингредиенты',
    modifierName: 'Название (напр. Сыр)',
    noModifiers: 'Нет модификаторов',
    addModifier: 'Добавить модификатор',
    from: 'от ',
    pricePlus: 'Цена (+)',
    tabNutrition: 'Метки и КБЖУ',
    selectedTags: 'Выбрано',
    wineCountry: 'Страна',
    whiskeyType: 'Крепкое',
    allSections: 'Все разделы',
    mandatory: 'ОБЯЗАТЕЛЬНО',
    multipleChoice: 'МНОЖ. ВЫБОР',
    variantNamePlaceholder: 'Название (напр. Клубничный)',
    variantSizePlaceholder: 'Название (напр. 30 см)',
    dishImage: 'Изображение блюда',
    saveAsDraft: 'В черновик',
    timeRestriction: 'Ограничить по времени',
    timeRestrictionHint: 'Категория и её блюда будут показываться гостям только в указанный период',
    availableFrom: 'С',
    availableTo: 'До',
    scheduleDays: 'Дни работы',
    allDays: 'Все дни',
    day_1: 'Пн',
    day_2: 'Вт',
    day_3: 'Ср',
    day_4: 'Чт',
    day_5: 'Пт',
    day_6: 'Сб',
    day_7: 'Вс',
    scheduleActive: 'Активно сейчас',
    scheduleInactive: 'Недоступно сейчас',
    onlyAvailableTime: 'Доступно с %from% до %to%',
    // Login Page
    loginTitle: 'QR-table',
    loginSubtitle: 'Управляйте своим заведением легко и эффективно.',
    loginTab: 'Вход',
    registerTab: 'Регистрация',
    emailLabel: 'Email',
    passwordLabel: 'Пароль',
    emailPlaceholder: 'your@email.com',
    passwordPlaceholder: '••••••••',
    signInButton: 'Войти',
    signingInButton: 'Вход...',
    forgotPassword: 'Забыли пароль?',
    resetPasswordEmailSent: 'Ссылка для восстановления пароля отправлена на ваш Email',
    resetPasswordSuccess: 'Пароль успешно изменен',
    loginLockout: 'Слишком много попыток. Попробуйте через 2 минуты.',
    userNotFound: 'Пользователь не найден',
    registerInfoTitle: 'Регистрация',
    registerInfoText: 'Для создания аккаунта свяжитесь с поддержкой.',
    backToLogin: 'Вернуться ко входу',
    empowerTitle: 'Воплощайте идеи',
    empowerDescription: 'Полный контроль над вашим цифровым меню. Отслеживайте просмотры и увеличивайте выручку в реальном времени.',
    chefQuote1: '«Если хочешь стать великим шеф-поваром, ты должен работать с великими шеф-поварами. И именно это я и сделал». — Гордон Рамзи',
    chefQuote2: '«Ваше тело — не храм, это парк развлечений. Наслаждайтесь поездкой». — Энтони Бурден',
    chefQuote3: '«Еда — это способ общения. Через нее мы делимся эмоциями и культурой». — Массимо Боттура',
    chefQuote4: '«Рецепт не имеет души. Вы, как повар, должны вдохнуть душу в рецепт». — Томас Келлер',
    chefQuote5: '«Кулинария — это не наука, это искусство, которое требует терпения и страсти». — Вольфганг Пак',
    chefQuote6: '«Хорошая еда — это очень часто простая еда». — Энтони Бурден',
    chefQuote7: '«Если вы боитесь масла — используйте сливки». — Джулия Чайлд',
    chefQuote8: '«Сначала мы едим глазами, а потом уже всем остальным». — Поль Бокюз',
    chefQuote9: '«Кухня — это место, где рождаются воспоминания». — Ален Дюкасс',
    chefQuote10: '«Я не готовлю еду. Я готовлю впечатления». — Хестон Блюменталь',
    chefQuotesTitle: 'Мудрость от шефов',
    bannersLabel: 'Баннеры',
    chooseOne: 'Выберите один',
    chooseMultiple: 'Можно несколько',
    pleaseSelect: 'Пожалуйста, выберите',
    min: 'мин.',
    max: 'макс.',
    withPercent: '*с учетом процентов',
    // Lead Form
    yourName: 'Ваше имя',
    yourPhone: 'Номер телефона',
    yourCafeName: 'Название заведения',
    sendRequest: 'Отправить заявку',
    requestSentTitle: 'Заявка отправлена',
    requestSentMessage: 'Мы свяжемся с вами в ближайшее время!',
    fillAllFields: 'Пожалуйста, заполните все поля',
    yourTelegram: 'Ваш Telegram (@username)',
    sauces: 'Соусы',
    spiciness: 'Острота',
    sugarLevel: 'Уровень сахара',
    roastingLevel: 'Прожарка',
    ice: 'Лед',
    toppings: 'Топпинги',
    milk: 'Молоко',
    syrup: 'Сироп',
    sideDish: 'Гарнир',
    dressing: 'Заправка',
    bread: 'Хлеб',
    exclude: 'Убрать',
    size: 'Размер',
    volume: 'Объем',
    temperature: 'Температура',
    sugar: 'Сахар',
    dough: 'Тесто',
    addIngredients: 'Добавить ингредиенты',
    excludeIngredients: 'Убрать ингредиенты',
    autoTranslateCategory: 'Перевести всю категорию',
    linkPlaceholder: 'Ссылка (https://...)',
    confirmAutoTranslate: 'Вы уверены, что хотите запустить авто-перевод? Поля без перевода будут заполнены автоматически.',
    // Common Types
    withChicken: 'С курицей',
    withShrimp: 'С креветками',
    withBeef: 'С говядиной',
    withSalmon: 'С лососем',
    withPork: 'Со свининой',
    withVegetables: 'С овощами',
    classic: 'Классический',
    withCheese: 'С сыром',
    // Portions
    smallPortion: 'Маленькая',
    mediumPortion: 'Средняя',
    largePortion: 'Большая',
    // Common Ingredients
    extraMeat: 'Доп. мясо',
    extraCheese: 'Доп. сыр',
    mushrooms: 'Грибы',
    bacon: 'Бекон',
    egg: 'Яйцо',
    // Exclusions
    withoutOnion: 'Без лука',
    sugarFree: 'Без сахара',
    lactoseFree: 'Без лактозы',
    glutenFree: 'Без глютена',
    // Preparation
    grilled: 'На гриле',
    steamed: 'На пару',
    baked: 'Запеченный',
    // Temp
    hot: 'Горячий',
    cold: 'Холодный',
    // Common Categories
    catCombo: 'Комбо',
    catSalads: 'Салаты',
    catAppetizers: 'Закуски',
    catBurgers: 'Бургеры',
    catBurgersAndDoners: 'Бургеры и Донеры',
    catPizza: 'Пицца',
    catDrinks: 'Напитки',
    catDesserts: 'Десерты',
    catBreakfast: 'Завтраки',
    catLunch: 'Ланчи',
    catMainCourses: 'Основные блюда',
    catSoups: 'Супы',
    catSteaks: 'Стейки',
    catCocktails: 'Коктейли',
    catTeaCoffee: 'Чай и Кофе',
    catAlcohol: 'Алкоголь',
    catSides: 'Гарниры',
    catPasta: 'Паста',
    catFishAndSeafood: 'Рыба и морепродукты',
    catHotDishes: 'Горячие блюда',
    catKidsMenu: 'Детское Меню',
    catPastries: 'Выпечка',
    catBakeryAndBread: 'Выпечка и хлеб',
    catColdDrinks: 'Холодные напитки',
    catHotDrinks: 'Горячие напитки',
    catStreetFood: 'Стрит Фуд',
    catHotAppetizers: 'Горячие закуски',
    catColdAppetizers: 'Холодные закуски',
    catBar: 'Бар',
    catAlcoholicDrinks: 'Алкогольные напитки',
    catPastaAndRisotto: 'Паста и Ризотто',
    catSushiRolls: 'Роллы',
    catNoodles: 'Лапша',
    catFitnessMenu: 'Фитнес Меню',
    catGrill: 'Мангал / Гриль',
    catBeerSnacks: 'Закуски к пиву',
    catWineList: 'Винная карта',
    catSpirits: 'Крепкий алкоголь',
    catSoftDrinks: 'Безалкогольные напитки',
    catLemonades: 'Лимонады и Смузи',
    catPlatters: 'Блюда на компанию',
    catSeasonal: 'Сезонное меню',
    catVegan: 'Вегетарианское меню',
    catHookah: 'Кальян',
    catOriental: 'Восточная кухня',
    catPanAsian: 'Паназиатская кухня',
    catGeorgian: 'Грузинская кухня',
    catEuropean: 'Европейская кухня',
    takeAway: 'С собой',
    dineIn: 'В заведении',
    noGarlic: 'Без чеснока',
    noHerbs: 'Без зелени',
    extraSauce: 'Доп. соус',
    confirmDelete: 'Удаление блюда',
    confirmDeleteMessage: 'Вы уверены, что хотите удалить блюдо',
    copy: 'Копировать',
    tariffPlansTitle: 'Тарифные планы',
    tariffPlansSubtitle: 'Выберите подходящий набор инструментов для вашего бизнеса',
    planDescSmart: 'Самый популярный',
    planDescBusiness: 'Для профессионалов',
    popularBadge: 'Популярный',
    currentPlanLabel: 'Ваш текущий план',
    connectBtn: 'Подключить',
    helpWithChoice: 'Нужна помощь с выбором?',
    contactUs: 'Свяжитесь с нами',
    perMonth: '/ мес',
    featureUnlimitedDishes: 'Безлимитное количество блюд',
    featureMultilingualAI: 'Мультиязычность',
    featureModifiersVariants: 'Модификаторы и варианты',
    feature2GisAuto: 'Авто-выгрузка в 2ГИС',
    featureBanners: 'Баннеры',
    featureAllSmart: 'Все функции Smart',
    featureWaiterPanel: 'Панель официанта',
    featureTgBotWaiter: 'Привязка ТГ бота для официанта',
    featureAiWaiterChoice: 'ИИ официант поможет выбрать блюдо гостю',
    featureDataEntry: 'Заполним за вас до 100 позиций блюд',
    featureSubdomain: 'Собственный поддомен (name-cafe.qr-table.kz)',
    featureMultilingual: 'Мультиязычность',
    featureModifiers: 'Модификаторы',
    feature2Gis: 'Интеграция 2ГИС',
    upgradeBtn: 'Повысить тариф',
    downgradeBtn: 'Снизить тариф',
    translationError: 'Ошибка перевода. Проверьте баланс или настройки API.',
    sourceTextMissing: 'Сначала введите текст на русском (RU).',
    moveToDrafts: 'В черновик',
    returnToMenu: 'Вернуть в меню',
    duplicate: 'Дублировать',
    // Support Modal
    contactSupport: 'Связь с поддержкой',
    topic: 'Тема обращения',
    topicBilling: 'Проблема с подпиской / Оплата',
    topicTech: 'Техническая ошибка',
    topicFeature: 'Предложение по улучшению',
    topicQR: 'Вопрос по QR-кодам и печати',
    topicOther: 'Другое',
    ticketSubject: 'Тема сообщения (кратко)',
    ticketSubjectPlaceholder: 'Например: Не работает перевод',
    ticketDesc: 'Описание проблемы',
    ticketDescPlaceholder: 'Опишите подробно, что случилось...',
    screenshot: 'Скриншот или файл (необязательно)',
    attachFile: 'Добавить файл',
    changeFile: 'Изменить',
    sendTicket: 'Отправить обращение',
    sending: 'Отправка...',
    ticketSent: 'Обращение отправлено!',
    ticketSentDesc: 'Мы уже получили ваше сообщение и скоро ответим.',
    fileTooLarge: 'Файл слишком большой (макс 5МБ)',
    errorSending: 'Ошибка отправки: ',
    // Messages Component
    noDialogs: 'Нет диалогов',
    selectDialog: 'Выберите диалог слева',
    writeMessagePlaceholder: 'Напишите сообщение...',
    ticketInfo: 'Тикет',
    screenshotLink: 'Скриншот',
    statusNew: 'Новый',
    statusInProgress: 'В работе',
    statusResolved: 'Решено',
    statusClosed: 'Закрыто',
    problemDesc: 'Описание проблемы:',
    // QR Code Generator
    qrCodeMenuTitle: 'QR-код меню',
    preview: 'Предпросмотр',
    downloadPNG: 'Скачать PNG',
    downloadSVG: 'Скачать SVG',
    link: 'Ссылка',
    qrLinkHelp: 'Эту ссылку будут открывать гости, сканируя QR-код.',
    appearance: 'Внешний вид',
    patternColor: 'Цвет узора',
    backgroundColor: 'Цвет фона',
    establishmentLogo: 'Логотип заведения',
    currentLogo: 'Текущий логотип',
    replaceFile: 'Заменить файл',
    logoNotSelected: 'Логотип не выбран',
    upload: 'Загрузить',
    fileTooBig: 'Файл слишком большой! Максимальный размер 2MB',
    uploadImageError: 'Пожалуйста, загрузите изображение (PNG, JPG)',
    linkCopied: 'Ссылка скопирована!',
    errorSavingQR: 'Не удалось сохранить настройки',
    errorUploadingLogo: 'Ошибка при загрузке логотипа: ',
    // Contact Us Modal
    contactTitle: 'Связаться с нами',
    contactSubtitle: 'По вопросам тарифов и сотрудничества',
    selectPlan: 'Выберите тариф',
    iWantToConnect: 'Я хочу подключить:',
    currentPlan: 'Текущий тариф:',
    message: 'Сообщение',
    messagePlaceholder: 'Например: Хочу подключить тариф Business',
    contactSuccess: 'Заявка отправлена!',
    contactSuccessDesc: 'Мы свяжемся с вами в ближайшее время.',
    // Analytics
    missedRevenue: 'Упущенная выгода',
    missedClicks: 'Кликов по "Стоп-листу"',
    wantedToOrder: 'ХОТЯТ ЗАКАЗАТЬ',
    searchInsights: 'Что ищут гости',
    notFound: 'не найдено',
    found: 'найдено',
    clicks: 'кликов',
    totalViews: 'Просмотры',
    totalVisitors: 'Посетители',
    uniqueVisitors: 'Уникальные гости',
    totalMenuOpens: 'Всего открытий меню',
    topDishes: 'Топ блюд',
    popularity: 'популярность',
    stickerEfficiency: 'Эффективность меток',
    noStickerData: 'Нет данных по меткам',
    preferences: 'Предпочтения',
    activityOverTime: 'Активность по времени',
    overview: 'Обзор',
    menuAnalysis: 'Анализ меню',
    visualGraphics: 'Визуализация',
    estimatedLoss: 'Упущенная выгода',
    clicksInStopList: 'Кликов по стоп-листу',
    audienceLanguage: 'Язык аудитории',
    menuLeaderboard: 'Лидеры меню',
    needsAttention: 'Нужна поддержка',
    whatGuestsWant: 'Спрос гостей',
    hiddenGems: 'Скрытый потенциал',
    allDishesActive: 'Все меню активно!',
    visitorTraffic: 'Трафик посетителей',
    categoryInterest: 'Интерес к категориям',
    noData: 'Нет данных',
    analyticsSubtitle: 'Анализ эффективности вашего заведения',
    today: 'Сегодня',
    yesterday: 'Вчера',
    exportPDF: 'Экспорт PDF',
    exporting: 'Экспорт...',
    frameStyle: 'Стиль шаблона',
    selectTemplate: 'Выберите шаблон',
    downloadTemplate: 'Скачать шаблон',
    templateNone: 'Без рамки',
    templateSolid: 'Сплошной',
    templateLabel: 'Этикетка',
    templateSticker: 'Стикер',
    templateWhiteCard: 'Белая карта',
    templateDarkCard: 'Темная карта',
    logo: 'Логотип',
    logoTakenFromSettings: 'Используется логотип из основных настроек',
    noLogoInSettings: 'Логотип не загружен в основных настройках',
    uploadLogo: 'Загрузить логотип',
    cafeDescription: 'Описание заведения',
    cafeDescriptionPlaceholder: 'Расскажите немного о вашем заведении и его особенностях...',
    socialLinks: 'Социальные сети',
    instagram: 'Instagram',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    website: 'Сайт',
    maintenanceConfirm: 'Вы уверены, что хотите скрыть меню от гостей? Все активные QR-коды будут временно перенаправлять на страницу технических работ.',

    // QR Code Generator Extended
    pattern: 'Узор',
    eyes: 'Глаза',
    colors: 'Цвета',
    frame: 'Рамка',
    patternStyle: 'Стиль узора',
    eyeOuterFrame: 'Внешняя рамка глаза',
    eyeInnerDot: 'Внутренняя точка глаза',
    quickPalette: 'Быстрая палитра',
    frameText: 'Текст на рамке',
    font: 'Шрифт',
    printA4: 'Печать (A4 Лист)',
    quantityPerSheet: 'К-во на листе',
    createA4Sheet: 'Создать лист A4',
    a4ReadyMessage: 'Макет А4 готов к печати 300 DPI.',
    qrStyleSquare: 'Квадрат',
    qrStyleRounded: 'Округлый',
    qrStyleDots: 'Точки',
    qrStyleClassy: 'Классика',
    qrStyleClassyRounded: 'Классика (округ.)',
    qrStyleExtraRounded: 'Сильно округлый',
    qrStyleDot: 'Точка',
    'qrColor.pattern': 'Узор',
    'qrColor.background': 'Фон',
    'qrColor.eyeFrame': 'Рамка глаз',
    'qrColor.eyeDot': 'Точка глаз',
    qrColorFrame: 'Рамка',
    qrColorText: 'Текст',
    // PDF Report
    strategicIntelligence: 'Стратегия и Рекомендации',
    revenueRisk: 'Потенциальная упущенная выручка',
    trafficInsights: 'Анализ трафика',
    menuBalance: 'Баланс меню',
    expertTip: 'Совет эксперта',
    generatedDate: 'Дата генерации',
    scanMenu: 'Меню',
    analyticalReport: 'Аналитический Отчет',
    reportingPeriod: 'Отчетный период',
    topPerformingItems: 'Топ популярных блюд',
    attentionNeeded: 'Требуют внимания',
    categories: 'Категории',
    rank: 'Место',
    totalViewsLabel: 'Всего просмотров',
    // Table Management
    tableManagement: 'Управление столиками',
    tablesQR: 'QR Столиков',
    mainQR: 'Общий QR',
    generateRange: 'Авто-генерация',
    tableNumber: 'Номер стола',
    addTable: 'Добавить',
    tableExists: 'Такой столик уже существует',
    confirmDeleteTable: 'Вы уверены, что хотите удалить этот столик?',
    downloadQR: 'Скачать QR',
    enterTableCount: 'Введите количество столиков (например 10):',
    errorAddingTable: 'Ошибка при добавлении столика',
    noTables: 'Столики еще не добавлены',
    addTableHint: 'Добавьте столики, чтобы гости могли делать заказы через QR-код',
    deleteTable: 'Удалить столик',
    tablesCount: 'столиков добавлено',
    tableNum: '№',
    range: 'Генерация',
    directLink: 'Прямая ссылка',
    actions: 'Действия',
    downloadAll: 'Скачать все (ZIP)',
    downloadAllConfirm: 'Начать скачивание всех QR-кодов?',
    copyLink: 'Копировать ссылку',
    bulkDownload: 'Массовое скачивание',
    bulkDownloadConfirm: 'Создать один ZIP-архив со всеми столами?',
    downloadComplete: 'ZIP-архив успешно создан',
    personalizeQR: 'Настройте ваш QR код',
    bulkGenTitle: 'Массовая генерация',
    bulkGenDesc: 'Введите количество столиков, которые нужно создать автоматически (с 1 по N).',
    generate: 'Создать',
    tablesAdded: 'Столики успешно добавлены',
    workSchedule: 'График работы',
    workingHours: 'Часы работы',
    mon: 'Пн',
    tue: 'Вт',
    wed: 'Ср',
    thu: 'Чт',
    fri: 'Пт',
    sat: 'Сб',
    sun: 'Вс',
    everyDay: 'Ежедневно',
    weekdays: 'Будни',
    weekend: 'Выходные',
    isClosed: 'Закрыто',
    open24h: 'Круглосуточно',
    wifiName: 'Название Wi-Fi',
    wifiPassword: 'Пароль Wi-Fi',
    gallery: 'Галерея',
    addPhoto: 'Добавить фото',
    orDragHere: 'или перетащите сюда',

    // AI Waiter
    aiWaiterTitle: 'Умный Официант',
    aiWaiterWelcome: 'Привет! Я ИИ-официант. Что бы вы хотели заказать сегодня? (Например: Посоветуй легкий салат)',
    aiWaiterPlaceholder: 'Спросите меня о меню...',
    aiWaiterError: 'Упс! Кажется, я немного задумался. Попробуйте спросить еще раз.',

    // Waiter Panel
    waiter_panel: 'Панель официанта',
    dark_mode: 'Темная тема',
    dark_mode_desc: 'Экономит заряд и бережет глаза',
    notifications: 'Уведомления',
    push_notifications: 'Push-уведомления',
    in_browser: 'В браузере',
    tg_integration: 'Telegram Интеграция',
    tg_integration_desc: 'Присылать вызовы лично в ТГ',
    link_via_bot: 'Привязать через бота',
    my_tables: 'Мои столы',
    select_tables_desc: 'Выберите столы, которые вы обслуживаете',
    tg_notifications_desc: 'Получайте уведомления о заказах прямо в Telegram.',
    connect_telegram: 'Привязать Telegram',
    unlink_telegram: 'Отвязать Telegram',
    tg_connected: 'Telegram привязан',
    refresh_status: 'Проверить статус',
    tg_connect_hint: 'Нажмите на синюю кнопку и отправьте START боту, затем нажмите "Проверить статус".',
    no_tables_found: 'Столы не найдены',
    live_feed: 'Лента вызовов',
    all_clear: 'Все спокойно',
    no_calls_for_tables: 'Нет вызовов по вашим столам',
    no_active_calls: 'Нет активных вызовов',
    table: 'Стол',
    min_short: 'мин',
    accept: 'Принял',
    open_bills: 'Открытые счета',
    no_bills_for_tables: 'Счетов по вашим столам нет',
    no_active_bills: 'Нет активных счетов',
    back: 'Назад',
    bill_empty: 'Счет пуст',
    add_item: 'Дозаказать',
    close_bill: 'Закрыть счет',
    close_bill_confirm: 'Вы уверены, что хотите закрыть этот счет?',
    calls: 'Вызовы',
    bills: 'Счета',
    feed: 'Лента',
    orders: 'Заказы',
    history: 'История',
    menu: 'Меню',
    history_empty: 'История пуста',
    bill_paid: 'Счет оплачен',
    notes_hint: 'Обычные заметки хранятся 24 часа. Закрепленные — до удаления.',
    notes_all: 'Все',
    notes_global: 'Общие',
    notes_tables: 'По столам',
    no_notes: 'Нет заметок',
    new_note: 'Новая заметка',
    edit_note: 'Редактировать заметку',
    add_note: 'Добавить заметку',
    pin_note: 'Закрепить заметку',
    note_text_placeholder: 'Текст заметки...',
    post_note: 'Опубликовать',
    delete_note_confirm_title: 'Удалить заметку?',
    delete_note_confirm_msg: 'Это действие нельзя будет отменить.',
    pin: 'Закрепить',
    waiter_notes_global: 'Общая',
    notes: 'Заметки',
    chat_id: 'Чат ID',
    ok: 'ОК',
    show_qr_to_waiter: 'Показать QR официанту',
    scan_guest_qr: 'Сканировать QR гостя',
    order_found: 'Заказ найден',
    accept_and_save: 'Принять и перейти',
    qr_code_title: 'QR-код заказа',
    qr_code_desc: 'Покажите этот код официанту, чтобы он мог быстро принять ваш заказ.',
    addToStopList: 'В стоп-лист',
    aiChefTitle: 'ИИ-Шеф',
    order_error_title: 'Ошибка заказа',
    order_error_msg: 'Не удалось отправить заказ. Пожалуйста, попробуйте еще раз или позовите официанта.',
    enterTableNumber: 'Введите номер стола',
    enterTableDesc: 'Пожалуйста, укажите номер вашего стола для оформления заказа.',
    confirm: 'Подтвердить',
    comment: 'Комментарий',
    addComment: 'Добавить комментарий',
    commentPlaceholder: 'Напишите ваши пожелания к заказу...',
    sendComment: 'Отправить',
    commentSent: 'Комментарий отправлен!',
    orderSubmitted: 'Заказ отправлен',
    currentOrder: 'Уже заказано',
    placeOrder: 'Заказать',
    newItems: 'Новые позиции',
    totalToPay: 'К оплате',
    confirmOrder: 'Подтвердить заказ',
    orderConfirmationHint: 'Подойдите к столу, чтобы подтвердить детали заказа',
    reorder: 'Дозаказ',
    myBill: 'Мой чек',
    orderSentSuccess: 'Заказ отправлен!',
    newOrderTitle: 'Новый заказ!',
    details: 'Детали',
    totalForNew: 'Итого за новый',
    withService: 'С учетом',
    order: 'Заказ',
    enable_camera: 'Включить камеру',
    variant: 'Вариант',
    kcal: 'Ккал',
    with_photo: 'С фото',
    compact_view: 'Компактно',
    table_number_placeholder: 'Номер стола',
    save_changes: 'Сохранить',
    scan_instruction: 'Отсканируйте QR-код гостя для приема заказа',

    // Cover Quotes
    quote1: "Еда символизирует любовь, когда слова бессильны.",
    author1: "Алан Д. Волфельт",
    quote2: "Нельзя хорошо думать, любить и спать, если ты плохо пообедал.",
    author2: "Вирджиния Вулф",
    quote3: "Люди, которые любят поесть, — это всегда лучшие люди.",
    author3: "Джулия Чайлд",
    quote4: "Кулинария — это прежде всего люди. Еда — пожалуй, единственная универсальная вещь, обладающая силой объединять всех.",
    author4: "Гай Фиери",

    // Stickers
    sticker_new: "НОВОЕ",
    sticker_hit: "ХИТ",
    sticker_spicy: "ОСТРО",
    sticker_vegan: "ВЕГАН",
    sticker_nuts: "ОРЕХИ",
    sticker_non_alcoholic: "Б/А",

    // Simple Login Page
    loginTitleText: 'Вход в систему',
    emailOrUsername: 'Почта/Имя пользователя',
    showPass: 'Показать',
    hidePass: 'Скрыть',
    signInBtn: 'Войти',
    agreementText1: 'Продолжая, вы соглашаетесь с ',
    agreementText2: ' и ',
    agreementText3: '.',
    privacyPolicy: 'Политикой конфиденциальности',
    userAgreement: 'Пользовательским соглашением',
    footerUserAgreement: 'Пользовательское соглашение',
    footerPrivacyPolicy: 'Политика конфиденциальности',
    footerPublicOffer: 'Публичная оферта',

    // Dish Form & Menu Management
    tabMain: 'Основное',
    tabModifiers: 'Модификаторы',
    tabTagsNutrition: 'Метки и КБЖУ',
    language: 'Язык',
    autoTranslate: 'Автоперевод',
    drafts: 'Черновики',
    hasVariantsTitle: 'Размеры, объемы',
    hasVariantsDesc: 'Например: 25см (400г) / 35см (750г), 250мл / 500мл',
    variantNameAndSize: 'Название (размер / вес / объем)',
    variantPrice: 'Цена',
    variantPlaceholder: 'напр. 25 см (400 г), 0.5 л',
    recommendedSize1to1: 'Рекомендуется 1:1',
    modePhotoCard: 'С фото',
    modeList: 'Список (без фото)',
    dishDescriptionPlaceholder: 'Опишите ингредиенты, особенности вкуса или подачу блюда...',
    descriptionAndComposition: 'Описание и состав',
    dishNamePlaceholder: 'Например: Пицца 4 сыра или Капучино',
    modifiersHint: 'Добавьте соусы, степени прожарки, сиропы, добавки или гарниры',
    quickAdd: 'Быстрое добавление:',
    noModifiersYet: 'У этого блюда пока нет модификаторов. Нажмите кнопку ниже или выберите шаблон выше.',
    groupNamePlaceholder: 'Название группы (напр. Соусы)',
    deleteGroup: 'Удалить группу',
    mod_optional: 'Необязательный',
    mod_mandatory: 'Обязательный',
    mod_multiple: 'Множ. выбор',
    optionName: 'Название опции',
    addOption: 'Добавить опцию',
    addGroup: 'Добавить группу',
    dishTags: 'Метки блюда',
    dishTagsHint: 'Выберите готовые метки для винной, барной карты и меню, или добавьте свои:',
    customTags: 'Свои',
    clickToRemove: 'Нажмите, чтобы удалить',
    popularTags: 'Основные',
    wineSugar: 'Вино',
    countryRegion: 'Страна',
    otherCountry: 'Другое',
    searchCountryPlaceholder: 'Поиск страны (напр. Италия, Грузия, Казахстан, Испания...)',
    addCountryCustom: '+ Добавить',
    whiskeyAlcohol: 'Крепкое',
    customTagPlaceholder: 'Своя метка (напр. 12 лет, IPA, Авторское)',
    addTagBtn: 'Добавить',
    nutritionPer100g: 'Пищевая ценность на 100 г',
    nutritionTotal: 'Пищевая ценность (Общая)',
    characteristics: 'Характеристики',
    pcs: 'шт',
    liters: 'л',
    chooseVariant: 'Выберите вариант',
    editCategory: 'Редактировать категорию',
    categoryNamePlaceholder: 'Например: Завтраки',
    editSection: 'Редактировать раздел',
    sectionNamePlaceholder: 'Например: Бар, Кухня или Кальяны',
    sectionCategories: 'Категории в этом разделе',
    sectionCategoriesHint: 'Отметьте категории, которые должны входить в этот раздел',
    quickAddCategoryPlaceholder: 'Быстро добавить категорию в этот раздел...',
    inThisSection: 'В этом разделе',
    searchCategories: 'Поиск категорий...',
    noCategoriesFound: 'Категории не найдены',
    dishesCountShort: 'бл.',
    section: 'Раздел',
    ageRestrictionHint: 'Для категорий с алкогольной или табачной продукцией',
    saving: 'Сохранение...',
    start: 'Начать',
    confirm_delete: 'Удалить позицию?',
    copied: 'Скопировано',
    statusProcessingShort: 'В обработке',
    success: 'Успешно',
    aiSommelierTitle: 'Сомелье',
    noOrders: 'Нет активных заказов',
    noOrdersText: 'Ваши текущие заказы будут отображаться здесь',
    activeOrder: 'Актуальный заказ',
    myOrders: 'Мои заказы',
    authSuccess: 'Аккаунт создан!',
    statusAccepted: 'Принят',
    statusProcessing: 'Готовится',
    statusOnWay: 'В пути / Готов к выдаче',
    statusCompleted: 'Выполнен',
    statusRejected: 'Отменен',
    historyAuthTitle: 'История заказов',
    historyAuthDesc: 'Войдите или зарегистрируйтесь, чтобы просматривать историю ваших заказов.',
    login: 'Войти',
    register: 'Зарегистрироваться',
    or: 'или',
    loginWithGoogle: 'Войти через Google',
    noAccount: 'Нет аккаунта? Создать',
    hasAccount: 'Уже есть аккаунт? Войти',
    orderHistory: 'История заказов',
    emptyHistory: 'Вы еще не делали заказов',
    date: 'Дата',
    type: 'Тип',
    deliveryType: 'Доставка',
    pickupType: 'Самовывоз',
    callWaiter: 'Позвать официанта',
    howCanWeHelp: 'Чем помочь?',
    billCard: 'Счет (Карта)',
    billCash: 'Счет (Наличные)',
    requestSent: 'Запрос отправлен!',
    waiterNavigating: 'Официант уже спешит к вам.',
    scans: 'Сессии',
    noDataForPeriod: 'Нет данных за этот период',
    total: 'Итого',
    last7Days: 'Последние 7 дней',
    last30Days: 'Последние 30 дней',
    executiveSummary: 'Сводка',
    visitors: 'Посетители',
    trafficVolume: 'Объем трафика',
    expand: 'Развернуть',
    collapse: 'Свернуть',
    deleted: 'Удалено',
    deleteConfirmTitle: 'Подтверждение удаления',
    categoryDescriptionLabel: 'Описание (напр. блюда из мяса)',
    sectionsEmpty: 'Разделы пусты',
    in_hall: 'В зале',
    scan: 'Сканировать',
    availableMsg: 'Доступно',
    unavailableMsg: 'Недоступно',
    checkout: 'Оформление',
    contacts: 'Контакты',
    yourNamePlaceholder: 'Как к вам обращаться?',
    whereToDeliver: 'Куда привезти?',
    addressPlaceholder: 'Улица, дом, квартира',
    sendOrder: 'Отправить заказ',
    enterNameAlert: 'Пожалуйста, укажите ваше имя.',
    enterPhoneAlert: 'Пожалуйста, введите корректный номер телефона полностью.',
    enterAddressAlert: 'Пожалуйста, укажите адрес доставки.',

    // Characteristics & Pills
    pill_wine_red: 'Красное',
    pill_wine_red_desc: 'Красное вино - изготавливается из тёмных сортов винограда, обладает насыщенным вкусом, ягодными нотами и танинами.',
    pill_wine_white: 'Белое',
    pill_wine_white_desc: 'Белое вино - лёгкое и освежающее, производится из белого винограда или очищенного сока тёмного винограда.',
    pill_wine_rose: 'Розовое',
    pill_wine_rose_desc: 'Розовое вино - гармоничное и ароматное, получается при кратковременном контакте сока с кожицей тёмного винограда.',
    pill_wine_dry: 'Сухое',
    pill_wine_dry_desc: 'Сухое вино - остаточный сахар до 4 г/л, чистый натуральный вкус без выраженной сладости.',
    pill_wine_semidry: 'Полусухое',
    pill_wine_semidry_desc: 'Полусухое вино - остаточный сахар 4-18 г/л, приятный баланс лёгкой сладости и свежести.',
    pill_wine_semisweet: 'Полусладкое',
    pill_wine_semisweet_desc: 'Полусладкое вино - остаточный сахар 18-45 г/л, мягкий, округлый сладковатый профиль.',
    pill_wine_sweet: 'Сладкое',
    pill_wine_sweet_desc: 'Сладкое вино - десертное вино с высоким содержанием сахара (свыше 45 г/л).',
    pill_wine_brut: 'Брют',
    pill_wine_brut_desc: 'Брют - сухое игристое вино с минимальным содержанием сахара и элегантным перляжем.',

    pill_spirits_singlemalt: 'Single Malt',
    pill_spirits_singlemalt_desc: 'Single Malt (Односолодовый) - виски, произведённый на одной винокурне исключительно из 100% ячменного солода в медных кубах.',
    pill_spirits_blended: 'Blended',
    pill_spirits_blended_desc: 'Blended (Купажированный) - виски, созданный путём искусного смешивания солодовых и зерновых дистиллятов.',
    pill_spirits_singlegrain: 'Single Grain',
    pill_spirits_singlegrain_desc: 'Single Grain (Однозерновой) - виски, произведённый на одной винокурне с использованием пшеницы, кукурузы или ржи.',
    pill_spirits_blendedmalt: 'Blended Malt',
    pill_spirits_blendedmalt_desc: 'Blended Malt - купаж исключительно односолодовых виски с нескольких разных винокурен.',
    pill_spirits_singlepotstill: 'Single Pot Still',
    pill_spirits_singlepotstill_desc: 'Single Pot Still - традиционный ирландский виски из смеси соложеного и несоложеного ячменя в медном перегонном кубе.',

    country_ireland: 'Ирландия',
    country_ireland_desc: 'Ирландия - родина мягкого виски с тройной дистилляцией и легендарных напитков с чистым вкусом.',
    country_scotland: 'Шотландия',
    country_scotland_desc: 'Шотландия - родина скотча с вековыми традициями выдержки в дубовых бочках и богатым дымным или фруктовым профилем.',
    country_france: 'Франция',
    country_france_desc: 'Франция - мировой эталон виноделия, коньяка и премиальных аперитивов с богатой терруарной историей.',
    country_usa: 'США',
    country_usa_desc: 'США / Американский стиль - знаменит традиционным бурбоном из кукурузы и выдержкой в новых обожжённых дубовых бочках.',
    country_american: 'Америка',
    country_japan: 'Япония',
    country_japanese: 'Япония',
    country_japan_desc: 'Япония - утончённый гармоничный стиль дистилляции с филигранным балансом вкуса и мастерством исполнения.',
    country_italy: 'Италия',
    country_italy_desc: 'Италия - родина легендарных вермутов, аперитивов и благородных вин со средиземноморским характером.',
    country_spain: 'Испания',
    country_spain_desc: 'Испания - страна выразительных вин, игристой кавы, хереса и ярких гастрономических традиций.',
    country_georgia: 'Грузия',
    country_georgia_desc: 'Грузия - колыбель виноделия с 8000-летней историей и аутентичной выдержкой в глиняных квеври.',
    country_germany: 'Германия',
    country_germany_desc: 'Германия - родина эталонных рислингов с филигранной свежей кислотностью и минеральным профилем.',
    country_kazakhstan: 'Казахстан',
    country_kazakhstan_desc: 'Казахстан - локальное производство с бережным сохранением рецептур и современных стандартов качества.',
    country_chile: 'Чили',
    country_chile_desc: 'Чили - родина выдающегося Карменера и выразительных вин с ярким фруктовым характером.',
    country_portugal: 'Португалия',
    country_portugal_desc: 'Португалия - знаменита легендарными портвейнами, свежим Винью Верде и автохтонными сортами.',
    country_mexico: 'Мексика',
    country_mexico_desc: 'Мексика - родина благородной текилы и мескаля из 100% голубой агавы с вековыми традициями.',
    country_china: 'Китай',
    country_china_desc: 'Китай - древние традиции напитков и современные стандарты крафтовых дистиллятов.',
    country_korea: 'Корея',
    country_korea_desc: 'Корея - родина соджу и традиционных рисовых напитков с чистым мягким вкусом.',
    country_argentina: 'Аргентина',
    country_argentina_desc: 'Аргентина - мировая столица мощного Мальбека с высокогорных виноградников Мендосы.',
    country_australia: 'Австралия',
    country_australia_desc: 'Австралия - знаменита насыщенным Ширазом и смелыми инновациями в виноделии.',
    country_new_zealand: 'Новая Зеландия',
    country_new_zealand_desc: 'Новая Зеландия - эталон яркого Совиньон Блан с взрывным ароматом маракуйи и крыжовника.',
    country_austria: 'Австрия',
    country_austria_desc: 'Австрия - родина минерального Грюнер Вельтлинера и элегантных терруарных вин.',
    country_greece: 'Греция',
    country_greece_desc: 'Греция - колыбель античного виноделия с уникальными вулканическими сортами Санторини.',
    country_czech: 'Чехия',
    country_czech_desc: 'Чехия - родина легендарного светлого лагера Пльзеньского типа и традиционных настоек.',
    country_belgium: 'Бельгия',
    country_belgium_desc: 'Бельгия - мировая столица аббатского и траппистского пивоварения с вековыми рецептами.',
    country_switzerland: 'Швейцария',
    country_switzerland_desc: 'Швейцария - альпийский терруар с чистейшей водой и премиальными локальными традициями.',
    country_netherlands: 'Нидерланды',
    country_netherlands_desc: 'Нидерланды - родина женевера (исторического предшественника джина) и пивоварения.',
    country_south_africa: 'ЮАР',
    country_south_africa_desc: 'ЮАР - страна выдающегося Пинотажа и выразительного Шенен Блана Стелленбоса.',
    country_turkey: 'Турция',
    country_turkey_desc: 'Турция - традиционные напитки с богатым восточным пряным и фруктовым букетом.',
    country_uzbekistan: 'Узбекистан',
    country_uzbekistan_desc: 'Узбекистан - солнечный край с богатыми традициями сладкого виноделия и настоек.',
    country_armenia: 'Армения',
    country_armenia_desc: 'Армения - легендарная родина благородного коньяка и древнейших сортов винограда Арени.',
    country_azerbaijan: 'Азербайджан',
    country_azerbaijan_desc: 'Азербайджан - каспийский регион с солнечным виноградом и гранатовыми напитками.',
    countryOfOriginTpl: 'Страна происхождения: %country%. Аутентичный напиток со стандартами качества и терруаром региона.',
    drinkFeatureTpl: 'Особенность напитка: %tag%',
    unsavedChangesTitle: 'Несохранённые изменения',
    unsavedChangesMessage: 'У вас есть несохранённые изменения. Сохранить их перед выходом или закрыть без сохранения?',
    saveAndClose: 'Сохранить',
    discardAndClose: 'Закрыть без сохранения',
    continueEditing: 'Отмена'
};

export default ru;
